export function toISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function getWeekRange(offset: number): { from: string; to: string; label: string } {
  const now = new Date();
  const dow = now.getDay();
  const mondayDelta = dow === 0 ? -6 : 1 - dow;
  const monday = new Date(now);
  monday.setDate(now.getDate() + mondayDelta + offset * 7);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return {
    from: toISODate(monday),
    to: toISODate(sunday),
    label:
      monday.getMonth() === sunday.getMonth()
        ? `${monday.getDate()} – ${sunday.getDate()} ${sunday.toLocaleString('en', { month: 'long', year: 'numeric' })}`
        : `${monday.getDate()} ${monday.toLocaleString('en', { month: 'short' })} – ${sunday.getDate()} ${sunday.toLocaleString('en', { month: 'long', year: 'numeric' })}`,
  };
}

export function getMonthRange(offset: number): { from: string; to: string; label: string } {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth() + offset, 1);
  const last = new Date(now.getFullYear(), now.getMonth() + offset + 1, 0);
  return {
    from: toISODate(first),
    to: toISODate(last),
    label: first.toLocaleString('en', { month: 'long', year: 'numeric' }),
  };
}

export function formatDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function getMonthWeekBuckets(
  year: number,
  month: number,
): Array<{ from: string; to: string; label: string }> {
  const monthStart = new Date(year, month - 1, 1);
  const monthEnd = new Date(year, month, 0); // last day of month

  const dow = monthStart.getDay();
  const daysToMonday = dow === 0 ? -6 : 1 - dow;
  const firstMonday = new Date(monthStart);
  firstMonday.setDate(monthStart.getDate() + daysToMonday);

  const buckets: Array<{ from: string; to: string; label: string }> = [];
  const cursor = new Date(firstMonday);
  const shortMonth = monthStart.toLocaleString('en', { month: 'short' });

  while (cursor <= monthEnd) {
    const weekEnd = new Date(cursor);
    weekEnd.setDate(cursor.getDate() + 6);
    const from = cursor < monthStart ? new Date(monthStart) : new Date(cursor);
    const to = weekEnd > monthEnd ? new Date(monthEnd) : new Date(weekEnd);
    buckets.push({
      from: toISODate(from),
      to: toISODate(to),
      label: `${from.getDate()}–${to.getDate()} ${shortMonth}`,
    });
    cursor.setDate(cursor.getDate() + 7);
  }

  return buckets;
}
